//* Libraries imports
import { AlertTriangle } from "lucide-react";

//* Components Imports
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type PaymentDuplicateModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export function PaymentDuplicateModal({
  open,
  onOpenChange,
  onConfirm,
}: PaymentDuplicateModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="bg-amber-100 p-2.5 rounded-full shrink-0">
              <AlertTriangle className="size-6 text-amber-600" />
            </div>
            <AlertDialogTitle className="text-xl">
              Gerar nova cobrança?
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-4 text-base">
            <p className="text-muted-foreground">
              Já existe uma cobrança pendente para esta venda. Deseja realmente
              prosseguir e gerar uma nova cobrança?
            </p>

            <div className="bg-amber-50 border border-amber-100 p-4 rounded-lg text-amber-900 text-sm leading-relaxed">
              <span className="font-bold block mb-1">⚠️ Aviso importante:</span>
              Se você já realizou o pagamento, por favor{" "}
              <span className="font-bold underline">aguarde a compensação</span>
              . Gerar uma nova cobrança agora poderá resultar em pagamento em
              duplicidade.
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-2">
          <AlertDialogCancel className="border-slate-200">
            Voltar
          </AlertDialogCancel>
          <AlertDialogAction
            className={cn(
              buttonVariants({ variant: "destructive" }),
              "bg-amber-600 hover:bg-amber-700 text-white border-none",
            )}
            onClick={() => {
              onOpenChange(false);
              onConfirm();
            }}
          >
            Sim, gerar nova
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
